import React from "react";
import SelectLanguage from "./SelectLanguage";

const MenuButton = ({ onClick, langs, language }) => (
  <nav>
    <SelectLanguage language={language} langs={langs} />
    <a href="#menu" onClick={onClick}>
      Menu
    </a>
  </nav>
);

export default MenuButton;



// WEBPACK FOOTER //
// ./src/components/MenuButton.js